import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer2 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            setEmail('');
        }
    };

    const shopLinks = [
        { label: 'Sarees', path: '/template2/shop' },
        { label: 'Lehengas', path: '/template2/shop' },
        { label: 'Kurtas', path: '/template2/shop' },
        { label: 'Fusion Wear', path: '/template2/shop' },
        { label: 'Bridal Collection', path: '/template2/shop' },
    ];

    const customerCareLinks = [
        { label: 'Contact Us', path: '/template2/contact' },
        { label: 'Shipping Policy', path: '/template2/shipping-exchange' },
        { label: 'Returns & Exchange', path: '/template2/shipping-exchange' },
        { label: 'FAQs', path: '/template2/faqs' },
        { label: 'Track Order', path: '/template2/orders' },
    ];

    const legalLinks = [
        { label: 'Terms & Conditions', path: '/template2/terms' },
        { label: 'Privacy Policy', path: '/template2/privacy-policy' },
        { label: 'About Us', path: '/template2/about' },
    ];

    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&display=swap" rel="stylesheet" />

            <footer style={{ backgroundColor: '#0A0A0A', borderTop: '1px solid #2A2A2A' }}>
                {/* Main Footer */}
                <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
                    {/* Mobile: stacked, Desktop: 4-col grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
                        {/* Column 1: Brand */}
                        <div>
                            <h3
                                style={{
                                    fontFamily: "'Montserrat', sans-serif",
                                    fontSize: '24px',
                                    fontWeight: 800,
                                    color: '#FFFFFF',
                                    letterSpacing: '3px',
                                    marginBottom: '12px',
                                }}
                            >
                                RANG
                            </h3>
                            <p
                                style={{
                                    fontFamily: "'Montserrat', sans-serif",
                                    fontSize: '13px',
                                    color: '#A3A3A3',
                                    lineHeight: 1.7,
                                    marginBottom: '20px',
                                }}
                            >
                                Bold Indian fashion that celebrates the vibrant spirit of colour and craftsmanship.
                            </p>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                {[Instagram, Facebook].map((Icon, i) => (
                                    <a
                                        key={i}
                                        href="#"
                                        style={{
                                            width: '36px',
                                            height: '36px',
                                            border: '1px solid #2A2A2A',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            transition: 'all 0.3s ease',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#FF6B35';
                                            e.currentTarget.style.backgroundColor = '#FF6B35';
                                            e.currentTarget.querySelector('svg').style.color = '#FFFFFF';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = '#2A2A2A';
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                            e.currentTarget.querySelector('svg').style.color = '#A3A3A3';
                                        }}
                                    >
                                        <Icon style={{ width: '16px', height: '16px', color: '#A3A3A3', transition: 'color 0.3s' }} />
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Column 2: Shop */}
                        <div>
                            <h4 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '12px', fontWeight: 700, color: '#FF6B35', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '16px' }}>
                                Shop
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {shopLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '10px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Montserrat', sans-serif",
                                                fontSize: '13px',
                                                color: '#A3A3A3',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s',
                                            }}
                                            onMouseEnter={(e) => { e.currentTarget.style.color = '#FF6B35'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.color = '#A3A3A3'; }}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 3: Customer Care */}
                        <div>
                            <h4 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '12px', fontWeight: 700, color: '#FF6B35', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '16px' }}>
                                Customer Care
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {customerCareLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '10px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Montserrat', sans-serif",
                                                fontSize: '13px',
                                                color: '#A3A3A3',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s',
                                            }}
                                            onMouseEnter={(e) => { e.currentTarget.style.color = '#FF6B35'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.color = '#A3A3A3'; }}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 4: Contact & Newsletter */}
                        <div>
                            <h4 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '12px', fontWeight: 700, color: '#FF6B35', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '16px' }}>
                                Get in Touch
                            </h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Phone style={{ width: '14px', height: '14px', color: '#FF6B35' }} />
                                    <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '13px', color: '#A3A3A3' }}>+91 98765 43210</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Mail style={{ width: '14px', height: '14px', color: '#FF6B35' }} />
                                    <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '13px', color: '#A3A3A3' }}>hello@rang.in</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                    <MapPin style={{ width: '14px', height: '14px', color: '#FF6B35', flexShrink: 0, marginTop: '2px' }} />
                                    <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '13px', color: '#A3A3A3' }}>Mumbai, Maharashtra, India</span>
                                </div>
                            </div>
                            <form onSubmit={handleSubscribe} style={{ display: 'flex', gap: '0' }}>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Your email"
                                    style={{
                                        flex: 1,
                                        padding: '10px 12px',
                                        fontSize: '12px',
                                        backgroundColor: '#1A1A1A',
                                        border: '1px solid #2A2A2A',
                                        borderRight: 'none',
                                        color: '#FFFFFF',
                                        fontFamily: "'Montserrat', sans-serif",
                                        outline: 'none',
                                    }}
                                />
                                <button
                                    type="submit"
                                    style={{
                                        padding: '10px 16px',
                                        fontSize: '11px',
                                        fontWeight: 700,
                                        backgroundColor: '#FF6B35',
                                        color: '#FFFFFF',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontFamily: "'Montserrat', sans-serif",
                                        letterSpacing: '1px',
                                        textTransform: 'uppercase',
                                        transition: 'background-color 0.3s',
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#E85D26'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#FF6B35'; }}
                                >
                                    Join
                                </button>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div style={{ borderTop: '1px solid #2A2A2A', padding: '20px 0' }}>
                    <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex flex-col md:flex-row justify-between items-center gap-3">
                        <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '12px', color: '#525252' }}>
                            &copy; 2026 RANG. All rights reserved.
                        </p>
                        <div style={{ display: 'flex', gap: '20px' }}>
                            {legalLinks.map((link) => (
                                <span
                                    key={link.label}
                                    onClick={() => navigate(link.path)}
                                    style={{
                                        fontFamily: "'Montserrat', sans-serif",
                                        fontSize: '12px',
                                        color: '#525252',
                                        cursor: 'pointer',
                                        transition: 'color 0.3s',
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.color = '#FF6B35'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.color = '#525252'; }}
                                >
                                    {link.label}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer2;
